import React, { Component } from 'react'
import { StaticBox, FlowTable, Modal, LinkedInput, LinkedInputGroup, NoContentBox } from 'components/basic'
import { notify } from 'helpers'
import http from 'API/http'
import Datetime from 'react-datetime'
import { default as moment } from 'moment-timezone'

class AccessOrders extends Component {
  constructor (props) {
    super(props)
    this.state = {
      orders: [],
      stateFilter: '',
      loading: true,
      order: {},
      editModal: false
    }
  }
  componentDidMount () {
    this.getOrders(this.props.id)
  }
  componentWillReceiveProps (props) {
    if (props.updated === this.props.updated) return false
    this.getOrders(props.id)
  }
  async getOrders (id) {
    this.setState({loading: true})
    var [err, res] = await http.get('2.4/orders', {
      accessId: id
    })
    if (err) return this.setState({loading: false})
    this.setState({orders: res.data, loading: false})
  }
  deleteOrder (order) {
    notify.deleteConfirm('This will delete this order', async confirmed => {
      if (!confirmed) return
      var [err, res] = await http.delete('2.4/orders/' + order.orderId)
      if (err) return notify.alert('', res.cause, 'error')
      notify.alert('', 'Order deleted!', 'success')
      this.props.callback()
    })
  }
  async updateOrder (order) {
    order.requestedDateTime = moment(order.requestedDateTime).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
    var [err, res] = await http.put('2.4/orders/' + order.orderId, {...order, accessId: this.props.id})
    if (err) return notify.alert('', res.cause, 'error')
    notify.alert('', 'Order updated!', 'success')
    this.setState({editModal: false, order: {}})
    this.getOrders(this.props.id)
  }
  render () {
    return (
      <StaticBox cols={12} icon='first-order' title='Orders'>
        <FlowTable loading={this.state.loading} paginatable={5} data={this.state.orders.map(order => [
          <a className={(order.state === 'RECEIVED' ? 'table-link' : 'hidden')} onClick={() => this.setState({editModal: true, order: order}, console.log(order))}><i className='fa fa-edit' /></a>,
          order.operation,
          (order.state === 'DONE_FAILED' ? <span className='label orders-label label-danger'><b>{order.state}</b></span> : <span className='label orders-label label-success'><b>{order.state}</b></span>),
          order.service,
          moment.utc(order.requestedDateTime).format('YYYY-MM-DD HH:mm:ss'),
          <a className={(order.state === 'RECEIVED' ? 'table-link' : 'hidden')} onClick={() => this.deleteOrder(order)}><i className='fa fa-trash-o' /></a>
        ])}>
          <tr>
            <th className='buttons' />
            <th className='buttons'>Operation</th>
            <th style={{'width': '120px'}}>State</th>
            <th>Service</th>
            <th>Time</th>
            <th className='buttons' />
          </tr>
        </FlowTable>
        <Modal noOverflow title={'Edit ' + this.state.order.operation + ' on service ' + this.state.order.service} isOpen={this.state.editModal} close={e => this.setState({editModal: false})} buttons={[
            { text: 'Cancel', event: e => this.setState({editModal: false, order: {}}) },
            { text: 'Update', event: e => this.updateOrder(this.state.order) }
        ]}>
          <label>Operation time</label>
          <Datetime value={moment(this.state.order.requestedDateTime).format('YYYY-MM-DD HH:mm')} minTime={moment().toDate()} minDate={moment().toDate()} onChange={date => {
            this.setState({order: {...this.state.order, requestedDateTime: date}})
          }} dateFormat={'YYYY-MM-DD'} inputProps={{placeholder: 'As soon as possible.'}} timeFormat={'HH:mm'} renderInput={props =>
            <div className='input-group'>
              <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
              <input {...props} className='form-control' />
            </div>
          } />
          {this.state.order.operation === 'ACTIVATE' &&
          <LinkedInputGroup ref={(form) => { this.form = form }}>
            <div className='row'>
              <div className='col-md-12'>
                <label>Your Internal Reference</label>
                <LinkedInput validate={/.{1,}/} errorMessage='This field is required' context={this} path='order.spReference' />
              </div>
              <div className='col-md-12'>
                <label>Your subscription ID</label>
                <LinkedInput validate={/.{1,}/} errorMessage='This field is required' context={this} path='order.spSubscriptionId' />
              </div>
            </div>
          </LinkedInputGroup>
          }
          {this.state.activating && <NoContentBox icon='circle-o-notch fa-spin' text='' />}
        </Modal>
      </StaticBox>
    )
  }
}
export default AccessOrders



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/2.4/access/AccessOrders.js